import { clsx, type ClassValue } from "clsx";

/** Lightweight className merger. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
